import React from "react";
// import './App.css';
// import '../src/assets/css/bootstrap.min.css';
// import '../src/assets/css/owl.carousel.min.css';
// import '../src/assets/css/owl.theme.default.min.css';
// import '../src/assets/css/animate.min.css';
// import '../src/assets/css/smooth-scrollbar.css';
// import '../src/assets/css/lightbox.min.css';
// import '../src/assets/css/style.css';
// import '../src/assets/css/responsive.css';

import HomeHeroSection from "../Home/Sections/HomeHeroSection";
import AboutAreaSection from "../Home/Sections/AboutAreaSection";
import ResumeAreaSection from "../Home/Sections/ResumeAreaSection";
import ServicesArea from "../Home/Sections/ServicesArea";
import SkillsArea from "../Home/Sections/SkillsArea";
import PortfolioArea from "../Home/Sections/PortfolioArea";
import ContactArea from "../Home/Sections/ContactArea";

function Home() {
  return (
    <>
      <HomeHeroSection />
      <AboutAreaSection />
      <ResumeAreaSection />
      <ServicesArea />
      <SkillsArea />
      <PortfolioArea />
      <ContactArea />
    </>
  );
}

export default Home;
